<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content config-modal">

    <div class="modal-header border-0">
      <div>
        <h5 class="modal-title">Trocar de Cliente</h5>
        <small class="text-muted">
          Selecione o cliente desejado para continuar
        </small>
      </div>
      <button type="button" class="btn-close" (click)="dialogRef.close()"></button>
    </div>

    <div class="modal-body mt-3">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="col-sm-12 mb-3">
          <label class="cliente-label">Estado</label>
          <mat-form-field appearance="outline" class="w-100 campo-plano campo-filtro-adm">
            <mat-select
              [placeholder]="carregandoEstados ? 'Carregando estados...' : 'Selecione'"
              formControlName="estadoId"
              title="Filtrar por estado"
              (openedChange)="buscaEstado = ''">
              <div class="select-busca" (click)="$event.stopPropagation()">
                <i-lucide name="search" size="16" class="select-busca-icone"></i-lucide>
                <input
                  type="text"
                  class="select-busca-input"
                  placeholder="Buscar estado..."
                  title="Buscar estado"
                  [(ngModel)]="buscaEstado"
                  [ngModelOptions]="{ standalone: true }"
                  (keydown)="$event.stopPropagation()">

                <button
                  type="button"
                  class="select-busca-limpar"
                  title="Limpar busca"
                  aria-label="Limpar busca"
                  *ngIf="buscaEstado"
                  (click)="buscaEstado = ''; $event.stopPropagation()">
                  <i-lucide name="x" size="14"></i-lucide>
                </button>
              </div>

              <mat-option *ngIf="carregandoEstados" disabled>Carregando estados...</mat-option>
              <mat-option [value]="null" *ngIf="!carregandoEstados">Selecione</mat-option>

              <mat-option *ngFor="let estado of filtrarOpcoes(estados, buscaEstado, ['desNomeEstadoEst', 'desUfEst'])" [value]="estado.codEstadoEst">
                {{ estado.desNomeEstadoEst }} - {{ estado.desUfEst }}
              </mat-option>

              <div class="select-vazio" *ngIf="!carregandoEstados && filtrarOpcoes(estados, buscaEstado, ['desNomeEstadoEst', 'desUfEst']).length === 0">
                Nenhum estado encontrado
              </div>

            </mat-select>
            <span matSuffix class="spinner-border spinner-border-sm me-2" role="status" aria-label="Carregando estados" *ngIf="carregandoEstados"></span>
          </mat-form-field>
        </div>

        <div class="col-sm-12 mb-3">
          <label class="cliente-label">Município</label>
          <mat-form-field appearance="outline" class="w-100 campo-plano campo-filtro-adm">
            <mat-select
              [placeholder]="carregandoMunicipios ? 'Carregando municípios...' : 'Selecione'"
              formControlName="municipioId"
              title="Filtrar por município"
              (openedChange)="buscaMunicipio = ''">
              <div class="select-busca" (click)="$event.stopPropagation()">
                <i-lucide name="search" size="16" class="select-busca-icone"></i-lucide>
                <input
                  type="text"
                  class="select-busca-input"
                  placeholder="Buscar município..."
                  title="Buscar município"
                  [(ngModel)]="buscaMunicipio"
                  [ngModelOptions]="{ standalone: true }"
                  (keydown)="$event.stopPropagation()">

                <button
                  type="button"
                  class="select-busca-limpar"
                  title="Limpar busca"
                  aria-label="Limpar busca"
                  *ngIf="buscaMunicipio"
                  (click)="buscaMunicipio = ''; $event.stopPropagation()">
                  <i-lucide name="x" size="14"></i-lucide>
                </button>
              </div>

              <mat-option *ngIf="carregandoMunicipios" disabled>Carregando municípios...</mat-option>
              <mat-option [value]="null" *ngIf="!carregandoMunicipios">Selecione</mat-option>

              <mat-option *ngFor="let municipio of filtrarOpcoes(municipios, buscaMunicipio, ['desNomeMun'])" [value]="municipio.codMunicipioMun">
                {{ municipio.desNomeMun }}
              </mat-option>

              <div class="select-vazio" *ngIf="!carregandoMunicipios && filtrarOpcoes(municipios, buscaMunicipio, ['desNomeMun']).length === 0">
                Nenhum município encontrado
              </div>

            </mat-select>
            <span matSuffix class="spinner-border spinner-border-sm me-2" role="status" aria-label="Carregando municípios" *ngIf="carregandoMunicipios"></span>
          </mat-form-field>
        </div>

        <div class="col-sm-12 mb-3">
          <label class="cliente-label">Órgão</label>
          <mat-form-field appearance="outline" class="w-100 campo-plano campo-filtro-adm">
            <mat-select
              [placeholder]="carregandoOrgaos ? 'Carregando órgãos...' : 'Selecione'"
              formControlName="orgaoId"
              title="Filtrar por órgão"
              (openedChange)="buscaOrgao = ''">
              <div class="select-busca" (click)="$event.stopPropagation()">
                <i-lucide name="search" size="16" class="select-busca-icone"></i-lucide>
                <input
                  type="text"
                  class="select-busca-input"
                  placeholder="Buscar órgão..."
                  title="Buscar órgão"
                  [(ngModel)]="buscaOrgao"
                  [ngModelOptions]="{ standalone: true }"
                  (keydown)="$event.stopPropagation()">

                <button
                  type="button"
                  class="select-busca-limpar"
                  title="Limpar busca"
                  aria-label="Limpar busca"
                  *ngIf="buscaOrgao"
                  (click)="buscaOrgao = ''; $event.stopPropagation()">
                  <i-lucide name="x" size="14"></i-lucide>
                </button>
              </div>

              <mat-option *ngIf="carregandoOrgaos" disabled>Carregando órgãos...</mat-option>
              <mat-option [value]="null" *ngIf="!carregandoOrgaos">Selecione</mat-option>

              <mat-option *ngFor="let orgao of filtrarOpcoes(orgaos, buscaOrgao, ['desNomeOrg', 'desSiglaOrg', 'desCnpjOrg'])" [value]="orgao.codOrgaoOrg">
                {{ orgao.desNomeOrg }}
              </mat-option>

              <div class="select-vazio" *ngIf="!carregandoOrgaos && filtrarOpcoes(orgaos, buscaOrgao, ['desNomeOrg', 'desSiglaOrg', 'desCnpjOrg']).length === 0">
                Nenhum órgão encontrado
              </div>

            </mat-select>
            <span matSuffix class="spinner-border spinner-border-sm me-2" role="status" aria-label="Carregando órgãos" *ngIf="carregandoOrgaos"></span>
          </mat-form-field>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">
          {{ mensagemErro }}
        </div>

        <div class="modal-footer border-0">
          <button type="button" class="btn btn-cancelar-modal" [disabled]="salvando" (click)="dialogRef.close()">
            Cancelar
          </button>
          <button
            class="btn btn-sm btn-warning text-white"
            type="submit"
            [disabled]="form.invalid || carregandoEstados || carregandoMunicipios || carregandoOrgaos || salvando">
            {{ salvando ? 'Trocando...' : 'Trocar cliente' }}
          </button>
        </div>

      </form>
    </div>
  </div>
</div>
